import { useMemo } from "react";

import type { GraphProps } from "@/features/shared/widgets/graphs/graph.types";

export function useLineGraphNoData(data: GraphProps["data"]): boolean {
  return useMemo(() => {
    return (
      data.lines?.every(
        (line) => !line.data || line.data.datapoints.every((d) => d.value === null),
      ) ?? true
    );
  }, [data]);
}
